import React, { useState } from "react";
import "./Table_section.css";
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleMinus, faCirclePlus } from "@fortawesome/free-solid-svg-icons";

function Table_section({yearlyBreakdown}) {
  const data = [
    {
      year: 2025,
      principal: "₹ 2,27,878",
      interest: "₹ 2,27,878",
      total: "₹ 2,27,878",
      balance: "₹ 47,72,122",
      paid: "4.56%",
      monthlyBreakdown: [
        {
          month: "Mar",
          principal: "₹ 16,169",
          interest: "₹ 143,750",
          total: "₹ 149,919",
          balance: "₹ 49,93,831",
          paid: "0.12%",
        },
        {
          month: "Apr",
          principal: "₹ 16,169",
          interest: "₹ 143,750",
          total: "₹ 149,919",
          balance: "₹ 49,93,831",
          paid: "0.12%",
        },
        {
          month: "May",
          principal: "₹ 16,169",
          interest: "₹ 143,750",
          total: "₹ 149,919",
          balance: "₹ 49,93,831",
          paid: "0.12%",
        },
        {
          month: "Jun",
          principal: "₹ 16,169",
          interest: "₹ 143,750",
          total: "₹ 149,919",
          balance: "₹ 49,93,831",
          paid: "0.12%",
        },
      ],
    },
    {
      year: 2026,
      principal: "₹ 2,27,878",
      interest: "₹ 2,27,878",
      total: "₹ 2,27,878",
      balance: "₹ 44,71,125",
      paid: "10.58%",
      monthlyBreakdown: [],
    },
    {
      year: 2027,
      principal: "₹ 2,27,878",
      interest: "₹ 2,27,878",
      total: "₹ 2,27,878",
      balance: "₹ 41,36,958",
      paid: "17.26%",
      monthlyBreakdown: [],
    },
  ];

  const [expandedRows, setExpandedRows] = useState({});

  const toggleRow = (year) => {
    setExpandedRows((prev) => ({
      ...prev,
      [year]: !prev[year],
    }));
  };

  return (
    <>
      <div className="Table_section">
        <div className="table-responsive">
          <Table bordered hover className="loan-table">
            <thead>
              <tr>
                <th className="gray_th">Year</th>
                <th className="light_blue_th">Principle (A)</th>
                <th className="orange_th">Interest (B)</th>
                <th>Total Payment (A+B)</th>
                <th className="dark_blue_th">Balance</th>
                <th>Loan Paid to Date</th>
              </tr>
            </thead>
            <tbody>
              {yearlyBreakdown?.map((row, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td className="gray_td">
                      <div
                        className="year_div"
                        onClick={() => toggleRow(row.year)}
                      >
                        <div className="icon_holder">
                          <FontAwesomeIcon
                            icon={
                              expandedRows[row.year]
                                ? faCircleMinus
                                : faCirclePlus
                            }
                            className="toggle_icon"
                          />
                        </div>
                        <div className="yr_text_div">
                          <p className="yr_text">{row.year}</p>
                        </div>
                      </div>
                    </td>
                    <td>{row.principalPaid}</td>
                    <td>{row.interestPaid}</td>
                    <td>{row.totalPaid}</td>
                    <td className="gray_td">{row.remainingBalance}</td>
                    <td>{row.percentagePaid}</td>
                  </tr>
{/* 
                  {expandedRows[row.year] &&
                    row.monthlyBreakdown.map((monthRow, i) => (
                      <tr key={i} className="expanded_row">
                        <td>{monthRow.month}</td>
                        <td>{monthRow.principal}</td>
                        <td>{monthRow.interest}</td>
                        <td>{monthRow.total}</td>
                        <td>{monthRow.balance}</td>
                        <td>{monthRow.paid}</td>
                      </tr>
                    ))} */}
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
}

export default Table_section;
